import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logoMedical from "../../assets/logo-medical.png";
import NextButton from "../../components/NextButton";
import { useGameTexts } from "../../hooks/useGameTexts";
import { SERVER_URL } from "../../api";
import { ROUTES } from "../../utils/constants";

function buildImageUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

function Scenario5Part2Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state?.group);
	const { texts, ready } = useGameTexts(group?.game);
	const [imageLoaded, setImageLoaded] = useState(false);

	const imageUrl = texts["scenario5.2.intro.image"] ? buildImageUrl(texts["scenario5.2.intro.image"]) : null;
	const nextSceneImagePath = texts["scenario5.2.intro2.image"];

	// Precargar imagen de la siguiente escena (intro2) para que al llegar no parpadee
	useEffect(() => {
		if (!nextSceneImagePath || typeof nextSceneImagePath !== "string") return;
		const nextUrl = buildImageUrl(nextSceneImagePath);
		if (!nextUrl) return;
		const img = new Image();
		img.src = nextUrl;
	}, [nextSceneImagePath]);

	// Precargar imagen en segundo plano; solo mostrar cuando esté cargada para evitar parpadeo
	useEffect(() => {
		if (!imageUrl) {
			setImageLoaded(false);
			return;
		}
		setImageLoaded(false);
		const img = new Image();
		let cancelled = false;
		img.onload = () => { if (!cancelled) setImageLoaded(true); };
		img.onerror = () => { if (!cancelled) setImageLoaded(false); };
		img.src = imageUrl;
		return () => { cancelled = true; img.src = ""; };
	}, [imageUrl]);

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} alt="" />
				</div>
				<div
					style={{ paddingLeft: "6vh" }}
					className="row d-flex justify-content-start align-items-start pt-5"
				>
					<div className="col-12">
						{!ready ? (
							<div style={{ width: "90%", height: 350, background: "#e0e0e0", borderRadius: 8 }} aria-hidden />
						) : imageUrl && imageLoaded ? (
							<img width="90%" src={imageUrl} alt="" style={{ display: "block" }} />
						) : (
							<div style={{ width: "90%", height: 350, background: "#e0e0e0", borderRadius: 8 }} aria-hidden />
						)}
					</div>
					<div
						className="container"
						style={{
							position: "absolute",
							right: "7vh",
							bottom: "7vh",
						}}
					>
						<div className="d-flex justify-content-end">
							<NextButton
								navigateTo={ROUTES.SCENARIO5_PART2_INTRO2}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario5Part2Intro);
